 
export const RestrictionLimitedPeriod = Object.freeze({
    RestrictionPeriod: 1,
    Week: 2,
});

export const RestrictionLimitedPeriodTKey = Object.freeze({
    [RestrictionLimitedPeriod.RestrictionPeriod]: 'restrictionPeriod',
    [RestrictionLimitedPeriod.Week]: 'week',
});

export default RestrictionLimitedPeriod;
